import { getTourData } from 'aria-viewer/analytics/utils/analyticUtils'
import { trackEvent } from 'aria-viewer/core/middleware/analyticsMiddleware'
import * as EVENTS from 'aria-viewer/analytics/constants'
import { PLAY_POSITION_MEDIA_VIDEO } from 'aria-viewer/players/panoplayer/actions/positionalMediaActions'
import {
    HOTSPOT_MODAL_VIDEO_ENDED,
    HOTSPOT_MODAL_VIDEO_PLAY,
    HOTSPOT_MODAL_VIDEO_PAUSE,
    HOTSPOT_MODAL_VIDEO_DRAGEND,
} from '../actions/hotspotModalActions'
import { EXPAND_INTERACTIVE_ELEMENTS_LIST, LIST_ITEM_SELECTED } from '../actions/interactiveElementsListActions'
import { PostionalMediaActions, InteractiveElementActions, MediaStates, CommonActionTypes } from '../constants'
import { MEDIA_TYPES } from 'aria-viewer/tour/constants'

const interactiveElementsAnalytics = {
    [PLAY_POSITION_MEDIA_VIDEO]: (getState, action) => {
        const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)

        return trackEvent(action.autoPlay ? EVENTS.POSITIONALMEDIA_AUTOSTARTED : EVENTS.POSITIONALMEDIA_STARTED, {
            Institution: inst_name,
            Inst_ID: owner_id,
            Location: loc_name,
            Loc_ID: loc_id,
            Stop: stoptitle,
            Stop_ID: stopid,
        })
    },

    [PostionalMediaActions.SET_POSITIONAL_MEDIA_STATUS]: (getState, action) => {
        const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)

        return trackEvent(
            action.status == MediaStates.REPLAY ? EVENTS.POSITIONALMEDIA_COMPLETED : EVENTS.POSITIONALMEDIA_PAUSED,
            {
                Institution: inst_name,
                Inst_ID: owner_id,
                Location: loc_name,
                Loc_ID: loc_id,
                Stop: stoptitle,
                Stop_ID: stopid,
            }
        )
    },

    [CommonActionTypes.OPEN_MODAL]: (getState, action) => {
        const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)
        const {
            el: { type, mediaType, id },
        } = action

        const isTrigger = type == 'triggers'

        return trackEvent(isTrigger ? EVENTS.TRIGGER_OPENED : EVENTS.HOTSPOT_MODALOPENED, {
            Institution: inst_name,
            Inst_ID: owner_id,
            Location: loc_name,
            Loc_ID: loc_id,
            Stop: stoptitle,
            Stop_ID: stopid,
            Hotspot_Type: mediaType,
            Hotspot_Id: id,
        })
    },

    [CommonActionTypes.CLOSE_MODAL]: (getState, action) => {
        const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)
        const {
            el: { type, mediaType, id },
        } = action

        const isTrigger = type == 'triggers'

        return trackEvent(isTrigger ? EVENTS.TRIGGER_EXITED : EVENTS.HOTSPOT_EXITED, {
            Institution: inst_name,
            Inst_ID: owner_id,
            Location: loc_name,
            Loc_ID: loc_id,
            Stop: stoptitle,
            Stop_ID: stopid,
            Hotspot_Type: isTrigger ? MEDIA_TYPES.video360 : mediaType,
            Hotspot_Id: id,
        })
    },

    [HOTSPOT_MODAL_VIDEO_ENDED]: (getState, action) => {
        const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)
        const modal = getState().getIn(['interactiveElements', 'modal'])
        const { mediaType, type, id } = modal

        const isTrigger = type == 'triggers'

        return trackEvent(isTrigger ? EVENTS.TRIGGER_COMPLETED : EVENTS.HOTSPOT_VIDEOCOMPLETED, {
            Institution: inst_name,
            Inst_ID: owner_id,
            Location: loc_name,
            Loc_ID: loc_id,
            Stop: stoptitle,
            Stop_ID: stopid,
            Hotspot_Type: mediaType,
            Hotspot_Id: id,
        })
    },

    [HOTSPOT_MODAL_VIDEO_PLAY]: (getState, action) => {
        const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)
        const modal = getState().getIn(['interactiveElements', 'modal'])
        const { mediaType, type, id } = modal

        const isTrigger = type == 'triggers'

        return trackEvent(isTrigger ? EVENTS.TRIGGER_STARTED : EVENTS.HOTSPOT_VIDEOSTARTED, {
            Institution: inst_name,
            Inst_ID: owner_id,
            Location: loc_name,
            Loc_ID: loc_id,
            Stop: stoptitle,
            Stop_ID: stopid,
            Hotspot_Type: isTrigger ? MEDIA_TYPES.video360 : mediaType,
            Hotspot_Id: id,
        })
    },

    [HOTSPOT_MODAL_VIDEO_PAUSE]: (getState, action) => {
        const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)
        const modal = getState().getIn(['interactiveElements', 'modal'])
        const { mediaType, type, id } = modal

        const isTrigger = type == 'triggers'

        return trackEvent(isTrigger ? EVENTS.TRIGGER_PAUSED : EVENTS.HOTSPOT_VIDEOPAUSED, {
            Institution: inst_name,
            Inst_ID: owner_id,
            Location: loc_name,
            Loc_ID: loc_id,
            Stop: stoptitle,
            Stop_ID: stopid,
            Hotspot_Type: mediaType,
            Hotspot_Id: id,
        })
    },

    [HOTSPOT_MODAL_VIDEO_DRAGEND]: (getState, action) => {
        const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)
        const modal = getState().getIn(['interactiveElements', 'modal'])
        const { mediaType, type, id } = modal

        const isTrigger = type == 'triggers'

        return trackEvent(isTrigger ? EVENTS.TRIGGER_PANNED : EVENTS.HOTSPOT_PANNED, {
            Institution: inst_name,
            Inst_ID: owner_id,
            Location: loc_name,
            Loc_ID: loc_id,
            Stop: stoptitle,
            Stop_ID: stopid,
            Hotspot_Type: isTrigger ? MEDIA_TYPES.video360 : mediaType,
            Hotspot_Id: id,
        })
    },

    [InteractiveElementActions.TRIGGER_MOUSE_ENTERED]: (getState, action) => {
        const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)

        return trackEvent(EVENTS.TRIGGER_HOVERSTATE, {
            Institution: inst_name,
            Inst_ID: owner_id,
            Location: loc_name,
            Loc_ID: loc_id,
            Stop: stoptitle,
            Stop_ID: stopid,
        })
    },

    [CommonActionTypes.SET_VISITED]: (getState, action) => {
        if (action.visitedByStop === undefined) {
            const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)

            return trackEvent(EVENTS.ELEMENT_COUNTER_SHOWN, {
                Institution: inst_name,
                Inst_ID: owner_id,
                Location: loc_name,
                Loc_ID: loc_id,
                Stop: stoptitle,
                Stop_ID: stopid,
            })
        }
    },

    [EXPAND_INTERACTIVE_ELEMENTS_LIST]: (getState, action) => {
        const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)

        return trackEvent(EVENTS.ELEMENT_COUNTER_LIST_VIEWED, {
            Institution: inst_name,
            Inst_ID: owner_id,
            Location: loc_name,
            Loc_ID: loc_id,
            Stop: stoptitle,
            Stop_ID: stopid,
        })
    },

    [LIST_ITEM_SELECTED]: (getState, action) => {
        const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)
        const { elementType } = action

        return trackEvent(EVENTS.ELEMENT_COUNTER_TAP_TO_VIEW_ELEMENT, {
            Institution: inst_name,
            Inst_ID: owner_id,
            Location: loc_name,
            Loc_ID: loc_id,
            Stop: stoptitle,
            Stop_ID: stopid,
            Element_Type: elementType,
        })
    },

    [CommonActionTypes.OPEN_PREVIEW]: (getState, action) => {
        const type = action.el.get('previewType')
        const id = action.el.get('id')

        const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)

        return trackEvent(EVENTS.HOTSPOT_HOVERSTATE, {
            Institution: inst_name,
            Inst_ID: owner_id,
            Location: loc_name,
            Loc_ID: loc_id,
            Stop: stoptitle,
            Stop_ID: stopid,
            Hotspot_Type: type,
            Hotspot_Id: id,
        })
    },
}

export default interactiveElementsAnalytics
